import { render, staticRenderFns } from "./AddFileFooter.vue?vue&type=template&id=418ba4cf&scoped=true&"
import script from "./AddFileFooter.vue?vue&type=script&lang=js&"
export * from "./AddFileFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418ba4cf",
  null
  
)

export default component.exports